import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const IS_SPACE_POSITION_BOTTOM: boolean = isFeature('space-position-bottom');
